import { useAuth } from "src/hooks/useAuth";
import { useFeatureFlags } from "src/hooks/useFeatureFlags";
import { useAreFeatureFlagsResolved } from "src/hooks/stores/use-feature-flags-store";

export function useProductGate() {
  const { session, isLoggedIn, isLoading } = useAuth();
  const { enableGatedHomepage } = useFeatureFlags();
  const areFeatureFlagsResolved = useAreFeatureFlagsResolved();

  const isSessionPending = isLoading && !session;

  return {
    isLoggedIn,
    isGatedUser: !!enableGatedHomepage && !isLoggedIn,
    isGateResolved:
      !isSessionPending && (isLoggedIn || areFeatureFlagsResolved),
  };
}
